export const slug = "settings";
export const title = "Settings";
export const section = "Administration";
export const content = `
# Settings

The Settings page lets admins configure your food bank's operational parameters.

## Signup Window

The **Signup Window** controls the dates during which clients can register through the client portal without staff approval. Outside this window, new registrations are held for staff review.

- **Open Date** — when self-registration opens.
- **Close Date** — when self-registration closes.

## Distribution Times

Configure your regular Saturday distribution schedule here. The times you set are shown to clients in the portal and on the kiosk check-in screen.

- **Start Time** — when the queue opens.
- **End Time** — when check-ins close for the day.

## New-Year Setup

At the start of each calendar year, an admin must complete New-Year Setup before the system will accept new program enrollments. This includes:

1. Confirming the current year's benefit tiers for Sharing Tree.
2. Setting the signup window for the new season.
3. Archiving the previous year's data.

A **banner reminder** appears for admins on the Dashboard if New-Year Setup has not been completed by February 1st.

## Pickup Window Slots

Under **Sharing Tree → Pickup Windows**, you can create, edit, and delete time slots for benefit pickup. Each slot has a:

- **Label** (e.g., "Saturday 9am–11am")
- **Capacity** — maximum households per slot.
- **Date** — the pickup date.

Households are assigned to a slot during enrollment. Staff can reassign a household's slot from the Sharing Tree page.

## Tips

- Only **Admin** role users can access Settings.
- Changes to distribution times take effect immediately and are visible to clients in the portal.
`;
